import Swal from "sweetalert2";

export const confirmSubmit = async ({
  title = "Confirm Action",
  text = "Are you sure you want to continue?",
  icon = "warning",
  confirmText = "Submit",
  cancelText = "Cancel",
} = {}) => {
  const result = await Swal.fire({
    title,
    text,
    icon,
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    reverseButtons: true,
    allowOutsideClick: false,
    allowEscapeKey: false,
    width: "360px",

    didOpen: () => {
      const popup = Swal.getPopup();
      const titleEl = Swal.getTitle();
      const textEl = Swal.getHtmlContainer();
      const confirmBtn = Swal.getConfirmButton();
      const cancelBtn = Swal.getCancelButton();
      const iconEl = Swal.getIcon();

      /* Popup */
      if (popup) {
        popup.style.padding = "14px";
      }

      /* Title */
      if (titleEl) {
        titleEl.style.fontSize = "18px";
      }

      /* Text */
      if (textEl) {
        textEl.style.fontSize = "13px";
      }

      /* Icon */
      if (iconEl) {
        iconEl.style.margin = "6px auto 6px";
        iconEl.style.padding = "0";

        const svg = iconEl.querySelector("svg");
        if (svg) {
          svg.style.width = "100%";
          svg.style.height = "100%";
          svg.style.transform = "none";
        }
      }

      /* Confirm Button */
      if (confirmBtn) {
        confirmBtn.style.fontSize = "13px";
        confirmBtn.style.padding = "6px 18px";
        confirmBtn.style.backgroundColor = "#2563EB";
        confirmBtn.style.borderRadius = "6px";
      }

      /* Cancel Button */
      if (cancelBtn) {
        cancelBtn.style.fontSize = "13px";
        cancelBtn.style.padding = "6px 18px";
        cancelBtn.style.color = "#EF4444";
        cancelBtn.style.border = "1px solid #EF4444";
        cancelBtn.style.backgroundColor = "#FEF2F2";
        cancelBtn.style.borderRadius = "6px";
      }
    },
  });

  return result.isConfirmed;
};
